<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="
      modal.open
    "
    :z-index="2003"
    class="
      modal-alert
    ">
    <div
      class="
        page-content
      ">
      <section class="content">
        <h5 class="text-danger">
          <i class="el-icon-warning" />
          <span>
            {{ title || 'ผิดพลาด' }}
          </span>
        </h5>
        <p v-if="message">
          {{ message }}
        </p>
      </section>
      <section
        class="
          footer
        ">
        <el-button
          type="danger"
          @click="
            () => modal.open = false
          ">
          ตกลง
        </el-button>
      </section>
    </div>
  </el-dialog>
</template>

<script lang="js">

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      modal: {
        open: false
      }
    }
  },
  watch: {
    open(value) {
      this.modal.open = value
    },
    'modal.open': function(value) {
      if (!value) this.$emit('closed')
    }
  },
  mounted() {
    this.modal.open = this.open
  }
}
</script>

<style lang="css" scoped>

.modal-alert >>> .el-dialog {
  max-width: 420px;
}

.modal-alert >>> .el-dialog__header {
  padding: 0;
}

.page-content {
  padding : var(--size-lg);
  gap     : var(--size-sm);
}

.page-content .content {
  display        : flex;
  gap            : var(--size-sm);
  flex-direction : column;
  align-items    : flex-start;
}

.page-content .content h5 {
  margin      : 0;
  display     : flex;
  align-items : center;
  gap         : var(--size-xs);
}

.footer {
  display        : flex;
  justify-content: flex-end;
  gap            : var(--size-sm);
}

</style>
